import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ShoppingCartOutlined, CarOutlined, DollarCircleOutlined, AppstoreOutlined,
} from '@ant-design/icons';
import usePermissions from '../../hooks/usePermissions';
// Réutilise le style + le media-query mobile-only de la barre du cockpit
// (masquée ≥701px, safe-area APK) : rien à redéfinir.
import '../../pages/mobileCockpit/components/mobile/bottomNavigation.css';

/*
  ⑩ Barre de navigation basse GLOBALE (mobile), gardée par PERMISSIONS.
  - Mobile-only : la classe .mobile-action-bottom-nav est masquée ≥701px.
  - Gardée par usePermissions().can(cle) : chaque entrée n'apparaît que si l'accès
    est accordé (rôle + exceptions). L'admin voit tout ; le vendeur n'a pas
    « livraisons.voir » → 3 entrées ; le livreur (1 seule) → barre masquée.
  - Masquée sur /mobile* : le module cockpit rend déjà SA propre barre.
  - Routes plein-écran (utilisables partout, pas seulement dans /mobile).
*/
const ITEMS = [
  { key: 'commandes', label: 'Commandes', Icon: ShoppingCartOutlined, to: '/listeCommande', perm: 'commandes.voir' },
  { key: 'livraisons', label: 'Livraisons', Icon: CarOutlined, to: '/livraison_detail', perm: 'livraisons.voir' },
  { key: 'paiements', label: 'Paiements', Icon: DollarCircleOutlined, to: '/creances', perm: 'creances.voir' },
  { key: 'catalogue', label: 'Catalogue', Icon: AppstoreOutlined, to: '/varianteProduit', perm: 'produits.voir' },
];

export default function GlobalBottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { ready, can } = usePermissions();

  // Le cockpit (/mobile*) a déjà sa barre : on évite les deux barres empilées.
  if (pathname.startsWith('/mobile')) return null;
  if (!ready) return null; // droits pas encore chargés : pas de barre vide qui clignote

  const visibles = ITEMS.filter((i) => can(i.perm));
  if (visibles.length < 2) return null; // barre à 0/1 entrée = inutile

  return (
    <nav className="mobile-action-bottom-nav" aria-label="Navigation">
      {visibles.map(({ key, label, Icon, to }) => {
        const active = pathname === to || pathname.startsWith(`${to}/`);
        return (
          <button key={key} type="button" className={active ? 'is-active' : ''}
            onClick={() => { if (!active) navigate(to, { replace: true }); }}>
            <Icon /><span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
